import protocolManifest from "../../protocol-manifest.json";

export const PROJECT = {
  factoryAddress: protocolManifest.factoryAddress,
  links: {
    ceremony: "https://github.com/TONresistor/zk-resistor-ceremony",
    cli: "https://github.com/TONresistor/zk-resistor-cli",
    contracts: "https://github.com/TONresistor/zk-resistor-contracts",
    manifest: "/protocol-manifest.json",
    resistanceTools: "https://t.me/resistancetools",
    sdk: "https://github.com/TONresistor/zk-resistor-sdk",
    ton: "https://ton.org",
    verifier: "https://verifier.ton.org/UQB8W1W276GWiQpK88Sx46K20rsMrCKIezOpwFGJ4dhjW2O5",
  },
} as const;
